(function (angular) {
    'use strict';

    var ConversationManager = (function () {
        function ConversationManager() { }
        ConversationManager.prototype.initialise = function (_comapiConfig, _restClient, _networkManager, _conversationManager) {
            this._comapiConfig = _comapiConfig;
            this._restClient = _restClient;
            this._networkManager = _networkManager;
            this._conversationManager = _conversationManager;
        }
        ConversationManager.prototype.createConversation = function (conversationDetails) {
            return this._conversationManager.createConversation(conversationDetails);
        };
        ConversationManager.prototype.updateConversation = function (conversationDetails, eTag) {
            return this._conversationManager.updateConversation(conversationDetails, eTag);
        };
        ConversationManager.prototype.getConversation = function (conversationId) {
            return this._conversationManager.getConversation(conversationId);
        };
        ConversationManager.prototype.deleteConversation = function (conversationId) {
            return this._conversationManager.deleteConversation(conversationId);
        };
        ConversationManager.prototype.addParticipantsToConversation = function (conversationId, participants) {
            return this._conversationManager.addParticipantsToConversation(conversationId, participants);
        };
        ConversationManager.prototype.deleteParticipantsFromConversation = function (conversationId, participants) {
            return this._conversationManager.deleteParticipantsFromConversation(conversationId, participants);
        };
        ConversationManager.prototype.getParticipantsInConversation = function (conversationId) {
            return this._conversationManager.getParticipantsInConversation(conversationId);
        };
        /**
         * We want to override this to allow different scope parameter to be passed - foundation has an enum ...
         * NOTE: we will augment multiple parameters into the scope field.
         * scope=[profile|all]&includeClosed=[true|false]
         * 
         */
        ConversationManager.prototype.getConversations = function (scope, profileId) {
            var _this = this;
            return this._networkManager.ensureSession()
                .then(function (sessionInfo) {
                    var url = COMAPI_CHAT.Utils.format("{{urlBase}}/apispaces/{{apiSpaceId}}/chats", {
                        apiSpaceId: _this._comapiConfig.apiSpaceId,
                        urlBase: _this._comapiConfig.urlBase,
                    });

                    if (scope || profileId) {

                        url += "?";

                        // if (scope !== undefined) {
                        //     url += "scope=" + scope + "&";
                        // }

                        if (scope !== undefined) {
                            url += scope + "&";
                        }


                        if (profileId !== undefined) {
                            url += "profileId=" + profileId;
                        }
                    }

                    return _this._restClient.get(url)
                        .then(function (result) {
                            return Promise.resolve(result.response);
                        });
                });


        };
        ConversationManager.prototype.sendIsTyping = function (conversationId) {
            return this._conversationManager.sendIsTyping(conversationId);
        };
        ConversationManager.prototype.sendIsTypingOff = function (conversationId) {
            return this._conversationManager.sendIsTypingOff(conversationId);
        };
        return ConversationManager;
    }());

    angular.module('shared')
        .service('ConversationManager', ConversationManager);

})(window.angular);
